import React from "react";
import ViewSignatureSamplePopup from "./ViewSignatureSamplePopup";

export interface IViewSignatureSampleMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}

// Mobile uses the same centred modal (single column, internal scroll) as
// desktop instead of a bottom sheet.
const ViewSignatureSamplePopupMobileView = (props: IViewSignatureSampleMobileViewProps) => (
  <ViewSignatureSamplePopup
    showPopup={props.showPopup}
    setShowPopup={props.setShowPopup}
    titleId="sample-popup-mobile-title"
  />
);
export default ViewSignatureSamplePopupMobileView;
